

import base64 from 'vux/src/tools/base64/index.js'

import moment from "moment";

export default {
name: "orderDetail",
components:{

},
data(){
return {
upgradeTips: '',
dialogUpgrade: false,
orderID: this.$route.params.orderID,
token: this.$route.query.t,
order:{},
flag:false,
routeParams:this.$route.query,
channel:this.$route.query.channel,
ticket:this.$route.query.token,
account:this.$route.query.account,
client:this.$route.query.client,
showOL:this.$route.query.showOL,
descriptions:new Array(),
rollFlag:false,
countdownTime:'',
countdownStatus:false,
isUploading:this.$route.query.isUploading

}
},







created(){

},
mounted() {
console.log(this.channel)
if(this.channel !== 'hecaiyun'){
this.getOrderDetail();
}else{
console.log(this.channel)

window.sessionStorage.setItem('clientType',5)
this.h5sso();


}

if(this.client === '2'){
console.log(this.client,'client1')
this.$store.commit('UPDATE_HEAD',false);
document.title = '订单详情'
this.channel = 'hecaiyun'
}else{
console.log(this.client,'client2')
this.$store.commit('UPDATE_HEAD',false);
document.title = '订单详情'
}

this.$store.commit('UPDATE_FOOTER',false);
this.$store.commit('UPDATE_PAGE_TITLE','订单详情');

},
methods:{
shouye(){
let h5Url = this.order.endpoint + "/#/home?mianhuainToken=" + this.token
window.location.href = h5Url
},
goToOrderList(){
let h5Url = this.order.endpoint + "/#/order?mianhuainToken=" + this.token
window.location.href = h5Url
},
goTo(){
switch(this.order.status){
case 0:
this.goPay()
break;
case 1:
if(this.isUploading === undefined){
this.goUpload()
}

break;
case 2:
let editUrl = this.order.albumEndpoint + "/#/album/" + this.order.orderId + "?t=" +this.token + "&client=1" + "&channel=" + this.channel + "&albumId=" + this.order.albumId
window.location.href = editUrl;
break;
default:
let url = this.order.albumEndpoint
if(this.order.status === 12 && (this.order.nextStep === "1" || this.order.nextStep === "5")){
url += "/#/album/" + this.order.orderId + "?t=" +this.token + "&client=1" + "&channel=" + this.channel + "&albumId=" + this.order.albumId
}else{
url += "/#/preview/" + this.order.albumId + "?t=" +this.token + "&client=1" + "&channel=" + this.channel
}
window.location.href = url;
break;
}
},
goToPayUrl(){
let h5Url = this.order.endpoint + "/#/PayOver?oid=" + base64.encode(this.order.orderId)
+ "&mianhuainToken=" + this.token
window.location.href = h5Url
},
isWeiXinBrowser() {
var ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
console.log('当前浏览器是微信浏览器');
return true;
} else {
console.log('当前浏览器不是微信浏览器');
return false;
}
},
weixinUnauth() {
return this.isWeiXinBrowser() && !(this.token && this.token.length);
},
goPay(){
let isWeixin = this.isWeiXinBrowser();
if(this.channel === 'hecaiyun' || isWeixin){
console.log(this.order.prepay)
let self = this;
this.baseAjax({
url:'/pay/prepay',
showLoading:false,
type:'post',
authentication:self.token,
data:{
...self.order.prepay,
"payChannel": isWeixin ? 1 : 4
},
success:function (data) {
console.log(data)
if (isWeixin) {
console.log("当前是微信支付环境,请确认");
self.wecahtPay(data.signature);
return;
}
if(self.checkIsAppleDevice()){

if (data.isNeedUpgrade) {
self.dialogUpgrade = true;
self.upgradeTips = data.upgradeTips;
return;
}
console.log(data.mwebUrl)
const iframe = document.createElement("iframe");
iframe.style.display = "none";
iframe.setAttribute("src", data.mwebUrl);
iframe.setAttribute(
"sandbox",
"allow-top-navigation allow-scripts"
);
document.body.appendChild(iframe);

setTimeout(() => {
let z = 4
self.payTxt = '5'
self.payStatus = false
self.timer = setInterval(() => {
if(self.payTxt === '1'){
self.payTxt = '已完成支付'
self.payStatus = true
self.goToPayUrl()
clearInterval(self.timer);
}else{
self.payTxt = z + ''
z--
}
},1000)
self.$vux.confirm.show({
content:'<span style="letter-spacing:2px">是否已完成微信支付,5秒后将跳转订单支付状态查询</span>',
confirmText:'已完成支付',
cancelText:'取消',

onCancel () {
self.goToPayUrl()
},
onConfirm () {

}
})
}, 1500);
}else{
console.log('安卓支付')
console.log(data.mwebUrl + '%26mianhuainToken%3D' +  self.token)
window.location.href = data.mwebUrl + '%26mianhuainToken%3D' +  self.token
}
}
})


}else{
console.log('棉花相册的订单信息为：', this.order);

if(this.checkIsAppleDevice()){
window.webkit.messageHandlers.goPay.postMessage(this.order);
}else{
if(window.mianhuain != undefined){
let jsonStr = JSON.stringify(this.order)
window.mianhuain.goPay(jsonStr);
}
}

}
},
wecahtPay(signature) {
let self = this;
function onBridgeReady() {
WeixinJSBridge.invoke(
"getBrandWCPayRequest",
{
appId: signature.appId, //公众号名称，由商户传入
timeStamp: signature.timeStamp, //时间戳，自1970年以来的秒数
nonceStr: signature.nonceStr, //随机串
package: signature.package,
signType: signature.signType || "MD5", //微信签名方式：
paySign: signature.sign, //微信签名
},
function (res) {
if (res.err_msg == "get_brand_wcpay_request:ok") {
console.log('微信支付成功,即将跳转至支付成功页面');


self.$router.push({
path: "/PayOver",
query: {
oid: Base64.toBase64(self.payOrderId),
},
});
}
}
);
}
if (typeof WeixinJSBridge == "undefined") {
if (document.addEventListener) {
document.addEventListener(
"WeixinJSBridgeReady",
onBridgeReady,
false
);
} else if (document.attachEvent) {
document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
}
} else {
onBridgeReady();
}
},
goUpload(){
if(this.channel === 'hecaiyun'){
console.log(this.order)
let h5Url = this.order.endpoint
+ '/#/photoSelect?a=' + this.order.albumId
+ '&imax=' + this.order.sku.properties.template_limitImagesCountMax
+ '&imin=' + this.order.sku.properties.template_limitImagesCountMin
+ '&vmax=' + this.order.sku.properties.template_limitVideosCountMax
+ '&vmin=' + this.order.sku.properties.template_limitVideosCountMin
+ '&mianhuainToken=' + this.token
+ '&o=' + this.order.orderId

window.location.href = h5Url
}else{

if(this.checkIsAppleDevice()){
window.webkit.messageHandlers.goUpload.postMessage(this.order);
}else{
if(window.mianhuain != undefined){
let jsonStr = JSON.stringify(this.order)
window.mianhuain.goUpload(jsonStr);
}
}

}
},
checkIsAppleDevice(){
let u = navigator.userAgent, app = navigator.appVersion;
let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
let iPad = u.indexOf('iPad') > -1;
let iPhone = u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1;
if (ios || iPad || iPhone) {
return true;
} else {
return false;
}
},
switchStatus(status){
if(status === 0){
return '待支付'
}else if(status === 1){
return '待上传'
}else if(status === 2){
return '待编辑'
}else if(status === 3){
return '待打印'
}else if(status === 4){
return '待发货'
}else if(status === 5){
return '运输中'
}else if(status === 6){
return '待收货'
}else if(status === 7){
return '支付完成'
}else if(status === 8){
return '退款中'
}else if(status === 9){
return '已退款'
}else if(status === 10){
return '已取消'
}else if(status === 11){
return '已删除'
}else if(status === 12){
return '相册生成中'
}else if(status === 13){
return '交易完成'
}
},
getOrderDetail(){
console.log(this.token)
let self = this;
this.baseAjax({
url:'/order/get',
showLoading:true,
type:'post',
authentication:self.token,
data:{
"orderId":self.orderID
},
success:function (data) {
console.log('订单详情为：', data.order)
self.order = data.order || {};
self.flag = true
self.descriptions = self.order && self.order.description && self.order.description.split("\n")


if(self.order.remainingEditTime !== undefined){
self.countdown()
self.timer = setInterval(() => {
if(self.countdownStatus){
clearInterval(self.timer);
}
self.countdown()
}, 1000);
}else{
self.countdownStatus = true
}

}
})
},
h5sso(){
let self = this;
this.baseAjax({
url:'/user/h5/sso',
showLoading:true,
type:'post',
data:{
"account":self.account,
"channel":self.channel,
"ticket":self.ticket
},
success:function (data) {

self.token = window.sessionStorage.getItem('ssoToken')
self.getOrderDetail()
}
})
},
toTime(n){
return n >= 0 && n < 10 ? '0' + n : '' + n;
},
countdown(){
var oDate = new Date();
var oldTime = oDate.getTime();

var newTime = new Date(this.order.remainingEditTime.replace(/\-/g, "/")).getTime();

var second = Math.floor((newTime - oldTime) / 1000);
if(second <= 0){
this.countdownStatus =  true
}
var day = Math.floor(second / 86400);
second = second % 86400;
var hour = Math.floor(second / 3600);
second %= 3600; 
var minute = Math.floor(second / 60);
second %= 60;
let str = this.toTime(hour) + ":" + this.toTime(minute) + ":" + this.toTime(second)
this.countdownTime = str

}
}
}



// WEBPACK FOOTER //
// ./src/components/order/orderDetail.vue